import { useEffect, useState } from "react";
import {
    getLink,
    getOrder, sendEmail,
    sendText,
} from "../api/apis";
import { useNavigate, useParams } from "react-router";
import BottomSheet from "../components/BottomSheet";
import SwishModal from "../Modals/SwishModal";
import { useApp } from "../Context";

export default function OrderStatusPage() {
    const { orderId, restaurant } = useParams();
    const navigate = useNavigate();
    const [order, setOrder] = useState(null);
    const [sbo, setSbo] = useState(null)
    const [loading, setLoading] = useState(true);
    const [fetchCount, setFetchCount] = useState(0);
    const [send, setSend] = useState(false)
    const [swish, setSwish] = useState(null)
    const [recieptLink, setRecieptLink] = useState(null);
    const {sid} = useApp()

    useEffect(() => {
        let fetchCount = 0;
        let intervalId;

        const fetchOrderStatus = () => {
            getOrder(orderId).then((result) => {
                setOrder(result.order);
                setSbo(result.sbo);
                setLoading(false);
                setFetchCount((prev) => prev + 1);

                const isPaid = result.order?.order00?.paid === "1";

                if (isPaid) {
                    clearInterval(intervalId);
                    fetchLink(result.order)
                } else {
                    fetchCount += 1;

                    if (fetchCount === 10) {
                        clearInterval(intervalId);
                        intervalId = setInterval(fetchOrderStatus, 10000);
                    }
                }
            });
        };

        intervalId = setInterval(fetchOrderStatus, 1000);

        return () => clearInterval(intervalId);
    }, [orderId]);







    if (loading) {
        return (
            <div className="container text-center mt-5">
                <div className="spinner-border text-warning mt-3" role="status">
                </div>
            </div>
        );
    }

    async function fetchLink(order){
        const note = order.order00.orderid

        const link = await getLink(note);

        setRecieptLink(link?.link)
    }

    const goToPage = async() => {
        if(recieptLink){
            window.open(recieptLink, '_blank').focus();
        }
        
    }


    if (!order) {
        return (
            <div className="container text-center mt-5">
                <h3 className="text-danger">Ordern kunde inte hittas</h3>
            </div>
        );
    }

    const { order00 } = order;
    const isPaid = order00?.paid === "1";
    const amountKr = (parseInt(order00?.belopp) / 100).toFixed(2);

    return (
        <div className="container mt-5">
            <h2 className="text-center fw-bold text-dark mb-4 pt-3">Orderstatus</h2>

            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="card shadow-sm p-4">
                        <h4 className="fw-bold text-dark mb-3">Order #{parseInt(order00?.orderid)}</h4>


                        <div className="d-flex justify-content-between mb-2">
                            <span className="text-muted">Bord</span>
                            <span className="fw-bold">{order00?.bord || "Ej angivet"}</span>
                        </div>

                        <div className="d-flex justify-content-between mb-2">
                            <span className="text-muted">Belopp</span>
                            <span className="fw-bold">{amountKr} kr</span>
                        </div>


                        <div
                            className={`alert mt-3 d-flex align-items-center justify-content-between ${
                                isPaid ? "alert-success" : "alert-warning"
                            }`}
                            role="alert"
                        >
                          <span>
                            {isPaid && "✅ Ordern är betald"}
                              {!isPaid && fetchCount < 10 && (
                                  <>
                                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                      Hämtar status...
                                  </>
                              )}
                              {!isPaid && fetchCount >= 10 && "⚠️ Ordern är ännu inte betald"}
                          </span>
                        </div>


                        <hr className="my-2"/>

                        {/* Buttons based on payment status */}
                        {isPaid ? (
                            <div className="mt-2">
                                <h5 className="mb-2">Skicka kvitto</h5>
                                <button
                                    className="btn btn-warning fw-semibold w-100"
                                    onClick={() => setSend(true)}
                                >
                                    <i className="bi bi-receipt me-2"></i>Spara kvitto
                                </button>
                            </div>
                        ) : fetchCount >= 10 ? (
                            <div className="mt-2">
                                <h5 className="mb-2">Betala order</h5>
                                <button
                                    className="btn btn-outline-success w-100 d-flex align-items-center justify-content-center"
                                    style={{ height: "50px" }}
                                    onClick={() => setSwish(true)}
                                >
                                    <img
                                        src="https://hjarnkraft.se/wp-content/uploads/2023/04/Swish-Logo-Secondary-Light-BG.png"
                                        alt="Swish"
                                        style={{ height: "100%", objectFit: "contain" }}
                                    />
                                </button>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
            <RecieptModal/>
            <SwishModal show={swish} setShow={setSwish} order={orderId} sum={amountKr}/>
            <div className="w-100 text-center mt-4">
                <h5 className="text-muted">Sugen på något mer?</h5>
                <button className="btn btn-warning fw-semibold px-4 mt-1" onClick={() => {
                    navigate(`/${restaurant}/order`)
                }}>Ny order
                </button>
            </div>
        </div>
    );

    function RecieptModal() {
        const formatPhone = (phone) =>{
            if(phone[0] === "4"){
                return `0${phone.substring(2)}`
            }
            return phone
        }
        const [phone, setPhone] = useState(formatPhone(order?.order01?.tele) ?? "");
        const [email, setEmail] = useState("");
        const [message, setMessage] = useState(null); // null when no message shown
    
        const sendSms = async () => {
            if(phone.length<7){
                setMessage({ok:false, message: "Ofullständigt telefonnummer"})
                return
            }
            const response = await sendText(order.order00?.orderid, phone);
            if (response.ok) {
                setMessage({ ok: true, message: "SMS skickades!" });
            } else {
                console.warn("SMS failed: ", response.error);
                setMessage({ ok: false, message: "SMS kunde inte skickas" });
            }
        };
    
        const sendEmail = async () => {
            if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){
                setMessage({ok:false, message: "Ofullständig epost"})
                return
            }
            const response = await sendEmail(order.order00?.orderid, email);
            if (response.ok) {
                setMessage({ ok: true, message: "E-post skickades!" });
            } else {
                console.warn("Email failed: ", response.error);
                setMessage({ ok: false, message: "E-post kunde inte skickas" });
            }
        };
    
        return (
            <BottomSheet showModal={send} setShowModal={setSend} headerText="Spara kvitto">
                <div className="d-grid gap-3">
                    
                    {/* ✅ Message Box */}
                    {message && (
                        <div className={`alert ${message.ok ? "alert-success" : "alert-danger"} text-center py-2`}>
                            {message.message}
                        </div>
                    )}   
                    {/* Phone input + button */}
                    <div>
                        <label className="form-label mb-1">Telefonnummer</label>
                        <div className="input-group">
                            <input
                                type="tel"
                                className="form-control"
                                placeholder="0701234567"
                                value={phone}
                                onChange={(e) => {
                                    setMessage(null)
                                    setPhone(e.target.value)}
                                }
                            />
                            <button className="btn btn-outline-primary" type="button" onClick={sendSms}>
                                Skicka SMS
                            </button>
                        </div>
                    </div>
    
                    {/* Email input + button */}
                    <div>
                        <label className="form-label mb-1">E-postadress</label>
                        <div className="input-group">
                            <input
                                type="email"
                                className="form-control"
                                placeholder="namn@example.com"
                                value={email}
                                onChange={(e) => {
                                    setMessage(null)
                                    setEmail(e.target.value)
                                }}
                            />
                            <button className="btn btn-outline-secondary" type="button" onClick={sendEmail}>
                                Skicka E-post
                            </button>
                        </div>
                    </div>
    
                    {/* View receipt button */}
                    <div>
                        <button className="btn btn-warning ml-auto" onClick={goToPage}>
                            <i className="bi bi-download" /> Visa kvitto
                        </button>
                    </div>
                </div>
            </BottomSheet>
        );
    }
}
